import { css } from 'styled-components';
import { Fonts } from './Fonts';
import { Viewports } from './Viewports';
export const headingStyle = css(["", ";", "{", ";}", "{", ";}"], Fonts.bold(24), Viewports.for('large'), Fonts.bold(34), Viewports.for('xLargeUp'), Fonts.bold(40));